module.exports = __webpack_public_path__ + "img/武安钢铁.93ec1dea.jpg";